import { useState, useRef, useEffect } from "react";
import { API, authFetch } from "@/App";
import { toast } from "sonner";

export function useChat({ currentOrderId, emailContent, extractedData, setExtractedData, setEditedData }) {
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [isChatting, setIsChatting] = useState(false);
  const chatInputRef = useRef(null);
  const chatScrollRef = useRef(null);

  // Scroll chat to bottom
  useEffect(() => {
    if (chatScrollRef.current) {
      chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
    }
  }, [chatMessages]);

  const handleSendChat = async () => {
    if (!chatInput.trim()) return;
    const userMessage = chatInput.trim();
    setChatInput("");
    setChatMessages(prev => [...prev, { role: "user", content: userMessage }]);
    setIsChatting(true);

    try {
      const response = await authFetch(`${API}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: userMessage,
          order_id: currentOrderId,
          email_content: currentOrderId ? null : emailContent,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        setChatMessages(prev => [...prev, { role: "assistant", content: data.response }]);
        if (data.updated_extraction) {
          setExtractedData(data.updated_extraction);
          setEditedData({ ...data.updated_extraction });
          toast.success("Extraction mise à jour");
        }
      } else {
        const error = await response.json();
        setChatMessages(prev => [...prev, { role: "assistant", content: `Erreur: ${error.detail || "Une erreur s'est produite"}` }]);
      }
    } catch {
      setChatMessages(prev => [...prev, { role: "assistant", content: "Erreur de connexion. Veuillez réessayer." }]);
    } finally {
      setIsChatting(false);
    }
  };

  const handleChatKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendChat();
    }
  };

  const resetChat = () => setChatMessages([]);

  return {
    chatMessages, chatInput, setChatInput, isChatting,
    chatInputRef, chatScrollRef,
    handleSendChat, handleChatKeyPress, resetChat,
  };
}
